import { trackEventWithAttribution } from "./posthog-helpers";

type PostHogLike = {
  capture: (eventName: string, properties?: Record<string, unknown>) => void;
};

export type TutorAnalyticsEvent =
  | "tutor_landing_viewed"
  | "tutor_video_started"
  | "tutor_video_progressed"
  | "tutor_video_completed"
  | "tutor_cta_clicked"
  | "tutor_studio_viewed"
  | "tutor_onboarding_started"
  | "tutor_onboarding_step_completed"
  | "tutor_onboarding_completed"
  | "tutor_demo_started"
  | "tutor_demo_finished"
  | "curriculum_catalog_viewed"
  | "curriculum_course_viewed"
  | "curriculum_unit_opened"
  | "curriculum_chapter_previewed"
  | "curriculum_class_setup_started"
  | "curriculum_class_setup_completed"
  | "classroom_created"
  | "student_invite_copied"
  | "student_enrolled"
  | "classroom_selected";

export function trackTutorEvent(
  posthog: PostHogLike | null | undefined,
  eventName: TutorAnalyticsEvent,
  properties: Record<string, unknown> = {}
) {
  trackEventWithAttribution(posthog, eventName, {
    product_area: "tutor_studio",
    ...properties,
  });
}
